<script>
  import options from './CardMediumPI.options'
  export default options
</script>

<template>
  <article class="nyk-card-medium nyk-card-medium-pi" :class="classNameColor">
      <div class="nyk-card-medium__header">
          <h3 class="nyk-card-medium__header__title">{{ title }}</h3>
      </div>

      <div class="nyk-card-medium__content">
          <p class="nyk-card-medium__content__description">{{ description }}</p>
      </div>

      <div class="nyk-card-medium__footer">
        <details
            class="nyk-card-medium-pi__dropdown"
            v-if="piPartners.length"
            ref="dropdownRef"
            @keydown="onDropdownKeydown"
            @focusout="onDropdownFocusOut">
            <summary class="nyk-card-medium-pi__dropdown__summary" :aria-label="dropdownAriaLabel">
                {{ dropdownLabel }}
            </summary>
            <ul class="nyk-card-medium-pi__dropdown__list">
                <li v-for="(pi, index) in piPartners" :key="index" class="nyk-card-medium-pi__dropdown__item">
                    <a
                        :href="pi.url"
                        class="nyk-card-medium-pi__dropdown__link"
                        target="_blank"
                        rel="noopener noreferrer"
                        @click="onPartnerClick(pi.name, pi.isExternal)">
                        {{ pi.name }}
                    </a>
                </li>
            </ul>
        </details>
      </div>
  </article>
</template>
